<template>
  <div>
    <template v-if="isEditWelcomeGoogle">
      <div style="border-radius: 12px; padding: 8px 6px 2px; background-color: #f1f0f0">
        <div
          class="form-control"
          :class="{
            'has-error': errors.has('answer_text')
          }"
        >
          <autoresize-textarea
            maxlength="1000"
            ref="answer_text"
            class
            :placeholder="$t('Chatbot answers')"
            v-model.trim="messages"
            name="answer"
            data-vv-as="Answer"
            data-vv-name="answer_text"
            v-validate
            style="resize: none; display: inherit; margin-bottom: 5px"
          ></autoresize-textarea>
          <v-layout>
            <v-flex class="error--text">
              {{ errors.first('answer_text') }}
            </v-flex>
            <v-flex shrink class="text-xs-right caption grey--text">
              {{ messages.length }}/1000
            </v-flex>
          </v-layout>
        </div>
      </div>

      <div>
        <h2 style="display: inline">{{ $t('Choice') }}</h2>
        <div>
          <template>
            <v-layout>
              <v-flex class="pl-1">
                <template v-if="isEditWelcomeGoogle">
                  <template>
                    <div
                      class="form-control"
                      :class="{ 'has-error': errorTag['replies'].length > 0 }"
                    >
                      <tags
                        v-model="reply"
                        :tags="replies"
                        @tags-changed="addReplies('replies', $event)"
                        @before-adding-tag="checkQuickReply('replies', $event)"
                        style="margin-bottom: 5px"
                        :btnText="$t('Add choice')"
                      ></tags>
                    </div>
                  </template>
                  <div class="form-control has-error">
                    <template v-for="(error, errorKey) in errorTag">
                      <span :key="errorKey" class="text-error" v-if="error.length > 0">
                        <template v-if="error.includes('overmaxlength')">{{
                          $t('Message cannot be longer than 20 alphabets')
                        }}</template>
                        <template v-else-if="error.includes('overtagmax')">{{
                          $t('Choices cannot be more than 5 items')
                        }}</template>
                        <template v-else-if="error.includes('duplicate')">{{
                          $t('Duplicate Choice')
                        }}</template>
                      </span>
                    </template>
                  </div>
                </template>
                <template v-else>
                  <div class="quickreply">
                    <ul class="tags">
                      <template v-if="tab == 'all'">
                        <li class="tag" v-for="(reply, index) in replies" :key="'reply_' + index">
                          {{ reply.text }}
                        </li>
                        <div class="pl-2 primary--text" v-if="replies.length == 0">
                          {{ $t('No quick reply') }}
                        </div>
                      </template>
                    </ul>
                  </div>
                </template>
              </v-flex>
            </v-layout>
          </template>
        </div>
      </div>

      <div class="text-xs-center">
        <v-btn outline color="grey" :loading="loading" @click="cancleEdit">{{
          $t('cancel')
        }}</v-btn>
        <v-btn depressed color="primary" :loading="loading" @click="saveContent">{{
          $t('Save')
        }}</v-btn>
      </div>
    </template>
    <template v-else>
      <div
        class="message"
        v-if="messages != ''"
        style="word-break: break-word;
                  position: relative;
                  border-radius: 12px;
                  max-width: 200px;
                  overflow-wrap: break-word;
                  min-height: 22px;
                  min-width: 14px;
                  line-height: 15.36px;
                  overflow: hidden;
                  margin-bottom: 5px;
                  white-space: initial;
                "
      >
        <div style="font-size: 12px" :style="{ color: 'black' }">
          <div style="padding: 5px 8px 6px" :style="{ 'background-color': '#F1F0F0' }">
            <span style="line-height: 15.36px; line-height: 22px">
              <template v-if="messages != ''">
                <specialtext :text="messages"></specialtext>
              </template>
              <template v-else> </template>
            </span>
          </div>
        </div>
      </div>
      <div class="quickreply">
        <ul class="tags">
          <template v-if="tab == 'all'">
            <li class="tag" v-for="(reply, index) in replies" :key="'reply_' + index">
              {{ reply.text }}
            </li>
            <div class="pl-2 primary--text" v-if="replies.length == 0">
              {{ $t('No quick reply') }}
            </div>
          </template>
        </ul>
      </div>
    </template>
  </div>
</template>

<script>
import specialtext from '@/components/elements/specialtext'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea'
import Tags from '@/components/elements/Tags'
import { mapGetters } from 'vuex'
import { cloneDeep } from 'lodash'
export default {
  props: ['isEditWelcomeGoogle'],
  data: function() {
    return {
      messages: '',
      loading: false,
      tab: 'all',
      reply: '',
      errorTag: {
        replies: []
      },
      replies: []
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  created: function() {
    const vm = this
    try {
      let googleConfig = JSON.parse(vm.selectedBot.google_agent_config_json)
      if (
        googleConfig &&
        googleConfig.businessMessagesAgent &&
        googleConfig.businessMessagesAgent.conversationalSettings &&
        googleConfig.businessMessagesAgent.conversationalSettings.en
      ) {
        let googleEn = googleConfig.businessMessagesAgent.conversationalSettings.en
        let replies = []
        if (googleEn.conversationStarters) {
          replies = googleEn.conversationStarters.map(item => {
            if (item.suggestion && item.suggestion.reply) {
              return {
                id: item.suggestion.reply.text,
                text: item.suggestion.reply.text
              }
            }
          })
        }

        vm.messages = cloneDeep(googleEn.welcomeMessage.text)
        vm.cached_messages = cloneDeep(googleEn.welcomeMessage.text)
        vm.replies = cloneDeep(replies)
        vm.cached_replies = cloneDeep(replies)
      }
    } catch (error) {
      console.log(error)
    }
  },
  methods: {
    addReplies: function(type, newTags) {
      const vm = this
      vm.replies = newTags
    },
    checkQuickReply: function(type, obj) {
      this.errorTag[type] = []
      if (obj.tag.text == '') {
      } else if (obj.tag.text.length > 20) {
        this.errorTag[type].push('overmaxlength')
        obj.error()
      } else if (obj.type == 'add' && type == 'replies' && this.replies.length >= 5) {
        this.errorTag[type].push('overtagmax')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        // this.replies.map(t => t.text).indexOf(obj.tag.text) !== -1s
        this.errorTag[type].push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    cancleEdit() {
      const vm = this
      this.messages = cloneDeep(this.cached_messages)
      this.replies = cloneDeep(this.cached_replies)
      vm.$emit('update:isEditWelcomeGoogle', false)
    },
    async saveContent() {
      const vm = this
      vm.loading = true
      if (vm.replies.length > 0) {
        var repliesData = vm.replies.map(item => {
          if (item.text) {
            return {
              suggestion: {
                reply: {
                  text: item.text,
                  postbackData: item.text
                }
              }
            }
          }
        })
      }
      let body = {
        conversationalSettings: {
          en: {
            welcomeMessage: {
              text: vm.messages
            },
            conversationStarters: repliesData
          }
        }
      }
      let res = await vm.post(
        `google-business/${vm.selectedBot.pageid}/update-greeting-default-message`,
        body
      )
      if (res.success) {
        vm.$swal.fire({
          title: vm.$t('Successfully'),
          text: ``,
          type: 'success'
        })
        vm.cached_messages = cloneDeep(vm.messages)
        vm.cached_replies = cloneDeep(vm.replies)
        vm.$emit('update:isEditWelcomeGoogle', false)
      } else {
        vm.$swal.fire({
          title: 'error',
          type: 'error',
          text: ``
        })
      }
      vm.loading = false
    }
  },
  components: { AutoresizeTextarea, Tags, specialtext }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/welcomemessage/GoogleWelcomeIntent.vue